import { useNavigate, useParams } from "react-router-dom";
import { Box, Card, Button, Typography, Alert, AlertTitle } from "@mui/material";
import { useSelector } from "react-redux";
import ImagemEdit from "../../../../utils/imagemEdit";
import ObservacoesFeitas from "../../dlif/observacoesFeitas";
import { temPermissao } from "../../../../utils/permissoes";


export default function NavLateral({ estabelecimento, solicitacaoImportacao, setHabiliteThis, observacoesFeitas }) {
  const user = useSelector((state) => state.account.user);
  const { id } = useParams();
  const { action } = useParams();
  const navigate = useNavigate();
  // console.log(solicitacaoImportacao)

  return (
    <>
      <Card style={{ padding: 20, marginBottom: 20 }}>
        {solicitacaoImportacao?.importador?.status === 'Não Licenciado' ?
          <>
            <ImagemEdit data={solicitacaoImportacao?.importador} />

            <p style={{ fontSize: 14, textAlign: 'center' }}>
              NÃO LICENCIADO
            </p>
          </>
          :
          <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", placeItems: 'center' }}>
            <ImagemEdit
              data={estabelecimento}
              url={"/estabelecimento/change-logo"}
              local={"estabelecimentoId"}
              openEditLogo={false}
            // setOpenEditLogo={setOpenEditLogo}
            />
          </div>
        }

        <Typography align="center">
          Estado da solicitação de importação:
          <b> {solicitacaoImportacao?.status}</b>
        </Typography>

        <br />

        {solicitacaoImportacao?.declaracao &&
          <Typography align="center">
            Estado da solicitação de desalfandegamento:
            <b> {solicitacaoImportacao?.declaracao?.status}</b>
          </Typography>
        }
        {(solicitacaoImportacao?.solicitacaoArea === "Aprovado" && !solicitacaoImportacao?.declaracao) &&
          <Alert severity="info">
            <AlertTitle>Aguardando desalfandegamento</AlertTitle>
            Este processo está aguardando a solicitação de desalfandegamento.
          </Alert>
        }

        <br />
        {/* OPÇÕES PARA IMPORTAÇÃO */}
        {/* ######################################################################################################################## */}
        {solicitacaoImportacao?.solicitacaoArea === "Não Controlados" &&
          <Box>
            {solicitacaoImportacao?.status === "Análise" && (
              <>
                <Button
                  disabled={!temPermissao(user, ['solicitacaoImportacaoAnalise'])}
                  autoFocus
                  fullWidth
                  size="small"
                  color="success"
                  variant={action === "approve" ? "contained" : "outlined"}
                  // onClick={() => navigate(`/admin/dmts/solicitacao-de-importacao/approve/Analisado/${id}`)}
                  onClick={() => navigate(`/admin/dmts/solicitacao-de-importacao/approve/Analisado/${id}`)}
                >
                  Encaminhar para Directora Adjunta área técnica
                </Button>

                <Button
                  disabled={!temPermissao(user, ['solicitacaoImportacaoAnalise'])}
                  fullWidth
                  size="small"
                  color="error"
                  variant={action === "repprove" ? "contained" : "outlined"}
                  style={{ marginTop: 20 }}
                  onClick={() => navigate(`/admin/dmts/solicitacao-de-importacao/repprove/Reprovado/${id}`)}
                >
                  Reprovar Solicitação
                </Button>
              </>
            )}

            {solicitacaoImportacao?.status === "Analisado" && (
              <>
                <Button
                  disabled={!temPermissao(user, ['solicitacaoImportacaoAnalisado'])}
                  fullWidth
                  size="small"
                  color="success"
                  variant={action === "approve" ? "contained" : "outlined"}
                  onClick={() => navigate(`/admin/dmts/solicitacao-de-importacao/approve/Deferimento/${id}`)}
                >
                  Encaminhar para chefe de departamento
                </Button>

                <Button
                  disabled={!temPermissao(user, ['solicitacaoImportacaoAnalisado'])}
                  fullWidth
                  size="small"
                  color="error"
                  variant={action === "repprove" ? "contained" : "outlined"}
                  style={{ marginTop: 20 }}
                  onClick={() => navigate(`/admin/dmts/solicitacao-de-importacao/repprove/Análise/${id}`)}
                >
                  Voltar para Análise
                </Button>
              </>
            )}


            {solicitacaoImportacao?.status === "Deferimento" && (
              <>
                <Button
                  disabled={!temPermissao(user, ['solicitacaoImportacaoDeferimento'])}
                  fullWidth
                  size="small"
                  color="success"
                  variant={action === "approve" ? "contained" : "outlined"}
                  onClick={() => setHabiliteThis(true)}
                >
                  Aprovar e Emitir Certificado
                </Button>

                <Button
                  disabled={!temPermissao(user, ['solicitacaoImportacaoDeferimento'])}
                  fullWidth
                  size="small"
                  color="error"
                  variant={action === "repprove" ? "contained" : "outlined"}
                  style={{ marginTop: 20 }}
                  onClick={() => navigate(`/admin/dmts/solicitacao-de-importacao/repprove/Analisado/${id}`)}
                >
                  {/* Voltar para Chefe de Controle de Mercado */}
                  Voltar para Directora Adjunta área técnica
                </Button>
              </>
            )}
          </Box>
        }

        {/* OPÇÕES PARA CERTICADOS DE PRODUTOS CONTROLADO */}
        {/* ######################################################################################################################## */}
        {solicitacaoImportacao?.solicitacaoArea === "Controlados" &&
          <Box>
            {solicitacaoImportacao?.status === "Análise" && (
              <>
                <Button
                  disabled={!temPermissao(user, ['solicitacaoImportacaoControladosAnalise'])}
                  autoFocus
                  fullWidth
                  size="small"
                  color="success"
                  variant={action === "approve" ? "contained" : "outlined"}
                  // onClick={() => navigate(`/admin/dmts/solicitacao-de-importacao/approve/Analisado/${id}`)}
                  onClick={() => navigate(`/admin/dmts/solicitacao-de-importacao/approve/Analisado/${id}`)}
                >
                  Encaminhar para Directora Adjunta área técnica
                </Button>

                <Button
                  disabled={!temPermissao(user, ['solicitacaoImportacaoControladosAnalise'])}
                  fullWidth
                  size="small"
                  color="error"
                  variant={action === "repprove" ? "contained" : "outlined"}
                  style={{ marginTop: 20 }}
                  onClick={() => navigate(`/admin/dmts/solicitacao-de-importacao/repprove/Reprovado/${id}`)}
                >
                  Reprovar Solicitação
                </Button>
              </>
            )}

            {solicitacaoImportacao?.status === "Analisado" && (
              <>
                <Button
                  disabled={!temPermissao(user, ['solicitacaoImportacaoControladosAnalisado'])}
                  fullWidth
                  size="small"
                  color="success"
                  variant={action === "approve" ? "contained" : "outlined"}
                  onClick={() => navigate(`/admin/dmts/solicitacao-de-importacao/approve/Deferimento/${id}`)}
                >
                  Encaminhar para chefe de departamento
                </Button>

                <Button
                  disabled={!temPermissao(user, ['solicitacaoImportacaoControladosAnalisado'])}
                  fullWidth
                  size="small"
                  color="error"
                  variant={action === "repprove" ? "contained" : "outlined"}
                  style={{ marginTop: 20 }}
                  onClick={() => navigate(`/admin/dmts/solicitacao-de-importacao/repprove/Análise/${id}`)}
                >
                  Voltar para Análise
                </Button>
              </>
            )}


            {solicitacaoImportacao?.status === "Deferimento" && (
              <>
                <Button
                  disabled={!temPermissao(user, ['solicitacaoImportacaoControladosDeferimento'])}
                  fullWidth
                  size="small"
                  color="success"
                  variant={action === "approve" ? "contained" : "outlined"}
                  onClick={() => setHabiliteThis(true)}
                >
                  Aprovar e Emitir Certificado
                </Button>

                <Button
                  disabled={!temPermissao(user, ['solicitacaoImportacaoControladosDeferimento'])}
                  fullWidth
                  size="small"
                  color="error"
                  variant={action === "repprove" ? "contained" : "outlined"}
                  style={{ marginTop: 20 }}
                  onClick={() => navigate(`/admin/dmts/solicitacao-de-importacao/repprove/Analisado/${id}`)}
                >
                  {/* Voltar para Chefe de Controle de Mercado */}
                  Voltar para Directora Adjunta área técnica
                </Button>
              </>
            )}
          </Box>
        }

        {/* OPÇÕES PARA DESALFANDEGAMENTO */}
        {/* ######################################################################################################################## */}

        <Box>
          {solicitacaoImportacao?.declaracao?.status === 'Análise' &&
            <>
              <Button
                disabled={!temPermissao(user, ['solicitacaoDesalfandegamentoAnalise'])}
                autoFocus
                fullWidth
                size="small"
                color="success"
                variant={action === "approve" ? "contained" : "outlined"}
                onClick={() => navigate(`/admin/dmts/solicitacao-de-desalfandegamento/approve/Analisado/${id}`)}
              >
                {/* Encaminhar para Chefe de Controle de Mercado */}
                Encaminhar para Directora Adjunta área técnica
              </Button>

              <Button
                disabled={!temPermissao(user, ['solicitacaoDesalfandegamentoAnalise'])}
                fullWidth
                size="small"
                color="error"
                variant={action === "repprove" ? "contained" : "outlined"}
                style={{ marginTop: 20 }}
                onClick={() => navigate(`/admin/dmts/solicitacao-de-desalfandegamento/repprove/Reprovado/${id}`)}
              >
                Reprovar Solicitação
              </Button>
            </>
          }

          {solicitacaoImportacao?.declaracao?.status === "Analisado" && (
            <>
              {/* user?.funcao === "Chefe de Departamento" || */}
              <Button
                disabled={!temPermissao(user, ['solicitacaoDesalfandegamentoAnalisado'])}
                fullWidth
                size="small"
                color="success"
                variant={action === "approve" ? "contained" : "outlined"}
                onClick={() => navigate(`/admin/dmts/solicitacao-de-desalfandegamento/approve/Deferimento/${id}`)}
              >
                Encaminhar para chefe de departamento
              </Button>

              <Button
                disabled={!temPermissao(user, ['solicitacaoDesalfandegamentoAnalisado'])}
                fullWidth
                size="small"
                color="error"
                variant={action === "repprove" ? "contained" : "outlined"}
                style={{ marginTop: 20 }}
                onClick={() => navigate(`/admin/dmts/solicitacao-de-desalfandegamento/repprove/Análise/${id}`)}
              >
                Voltar para Análise
              </Button>
            </>
          )}

          {solicitacaoImportacao?.declaracao?.status === "Deferimento" && (
            <>
              <Button
                disabled={!temPermissao(user, ['solicitacaoDesalfandegamentoDeferimento'])}
                fullWidth
                size="small"
                color="success"
                variant={action === "approve" ? "contained" : "outlined"}
                onClick={() => setHabiliteThis(true)}
              >
                Aprovar e Emitir Declaração
              </Button>

              <Button
                disabled={!temPermissao(user, ['solicitacaoDesalfandegamentoDeferimento'])}
                fullWidth
                size="small"
                color="error"
                variant={action === "repprove" ? "contained" : "outlined"}
                style={{ marginTop: 20 }}
                onClick={() => navigate(`/admin/dmts/solicitacao-de-importacao/repprove/Analisado/${id}`)}
              >
                {/* Voltar para Chefe de Controle de Mercado */}
                Voltar para Directora Adjunta área técnica
              </Button>
            </>
          )}

        </Box>

      </Card>

      {observacoesFeitas.length !== 0 && (
        <ObservacoesFeitas observacoesFeitas={observacoesFeitas} />
      )}
    </>
  );
}
